export default __webpack_public_path__ + "static/media/team6.21f13ca1.png";